import {Component, inject} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {filter} from 'rxjs/operators';
import {TRANSLATOR_LANGUAGES_DATA} from "./models/translator";
import {TranslationService} from "./shared/translation/translation.service";
import {TranslateService} from "@ngx-translate/core";
import {LocalizeRouterService} from "@gilsdav/ngx-translate-router";
import {OSNotificationService} from "./services/o-s-notification.service";

/** Root must use default change detection: OnPush here skips `router-outlet` descendants until a DOM event (Angular #20611 / docs). */
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: false,
})
export class AppComponent {
  title = 'Smart Dining';

  languages = TRANSLATOR_LANGUAGES_DATA;
  selectedLanguage: any;
  showLanguageSwitch = false;

  private readonly osNotificationService = inject(OSNotificationService);
  private readonly router = inject(Router);

  constructor(
    private readonly translationService: TranslationService,
    private readonly translateService: TranslateService,
    private readonly localizeRouterService: LocalizeRouterService,
  ) {
    this.osNotificationService.checkNotificationPermission();
    this.syncLanguageSwitch(this.router.url);
    this.router.events.pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd)).subscribe((event) => {
      this.syncLanguageSwitch(event.urlAfterRedirects);
    });

    this.translateService.addLangs(this.languages.map(value => value.code));
    if (!this.translateService.currentLang) {
      this.translateService.setDefaultLang(this.translationService.getBrowserLanguage().toLowerCase());
    }

    this.translationService.getCurrentLanguage().subscribe({
      next: value => {
        const code = (value ?? '').toString().trim();
        if (!code) {
          return;
        }
        this.selectedLanguage = code;
        const lower = code.toLowerCase();
        this.translateService.use(lower);
        this.localizeRouterService.changeLanguage(lower);
      }
    });
  }

  switchLang(event: any) {
    const lang = event.target.value as string;
    if (lang) {
      this.translationService.setLanguage(lang.toLowerCase());
    }
  }

  private syncLanguageSwitch(url: string): void {
    this.showLanguageSwitch = /\/auth(\/|$)/.test(url);
  }

  requestPermissionAndShowNotification(): void {
    const notificationData = {
      body: "Voici la description de la notification.",
      icon: "assets/images/app-logo.png",
      title: "Welcome Smart Dining Admin",
      url: "https://smartdining.co"
    };

    if (typeof Notification === 'undefined') {
      return;
    }

    if (Notification.permission === 'granted') {
      this.osNotificationService.showNotification(notificationData);
    } else if (Notification.permission !== 'denied') {
      Notification.requestPermission().then(permission => {
        if (permission === 'granted') {
          this.osNotificationService.showNotification(notificationData);
        }
      });
    }
  }

}
